import TabGroupBancoDoAuto from '@/components/molecules/TabGroupBancoDoAuto';
import { BancoDoAutoTabs } from '@/data/misc/banco-do-auto-tabs';

export default function FinanciamentoDePesadosPage() {
  return <TabGroupBancoDoAuto tab={BancoDoAutoTabs['financiamento-de-pesados'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
